import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/authSlice';
import notificationReducer from './slices/notificationSlice'
import centerNotificationReducer from './slices/centernotificationSlice'
import countsReducer from './slices/countsSlice'

// Create a custom middleware to save state to localStorage
const localStorageMiddleware = store => next => action => {
  const result = next(action);
  const state = store.getState();
  
  localStorage.setItem('reduxState', JSON.stringify({
    user: {
      user: state.user.user,
      isAuthenticated: state.user.isAuthenticated,
      token: state.user.token,
      selectedYear: state.user.selectedYear
    }
  }));
  
  return result;
};

// Load state from localStorage
const loadFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('reduxState');
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState);
  } catch (e) {
    console.warn('Error loading state:', e);
    return undefined;
  }
};

const preloadedState = loadFromLocalStorage();

export const store = configureStore({
  reducer: {
    user: userReducer,
    notification: notificationReducer,
    centerNotification:centerNotificationReducer,
    counts: countsReducer,
  },
  preloadedState,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat(localStorageMiddleware)
});